import * as React from 'react';
import {LayerInteropContext, DeprecatedThemeContext} from '@sail/global-state';
import type {DeprecatedThemeValue} from '@sail/global-state';
import {themeGlobals, useTokenContext} from '@sail/engine/deprecated';
import {BaseProvider, view} from './index';
import {LayerInterop} from './LayerInterop';

type ProviderProps = React.ComponentProps<typeof BaseProvider>;

const deprecatedThemeValue: DeprecatedThemeValue = {
  view,
  themeGlobals,
  useTokenContext,
};

/**
 * Theme provider that applies classic theme tokens and injects LayerInterop
 * for deprecated token propagation in portals.
 */
export const Provider: React.FC<
  ProviderProps & {children?: React.ReactNode}
> = ({children, ...props}) => {
  return (
    <DeprecatedThemeContext.Provider value={deprecatedThemeValue}>
      <LayerInteropContext.Provider value={LayerInterop}>
        <BaseProvider {...props}>{children}</BaseProvider>
      </LayerInteropContext.Provider>
    </DeprecatedThemeContext.Provider>
  );
};
